import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const EditShopDetailsIndex = () => {
  const navigate = useNavigate();
  const { shop_id } = useParams();
  useEffect(() => {
    navigate(`/shop/${shop_id}/details`, { replace: true });
  }, []);

  return <div />;
};

export default EditShopDetailsIndex;
